export const FETCH_EXTERNAL_DASHBOARDS_SETTINGS_REQUEST =
  'externalDashboardsSettings/FETCH_EXTERNAL_DASHBOARDS_SETTINGS_REQUEST'
export const FETCH_EXTERNAL_DASHBOARDS_SETTINGS_SUCCESS =
  'externalDashboardsSettings/FETCH_EXTERNAL_DASHBOARDS_SETTINGS_SUCCESS'
export const FETCH_EXTERNAL_DASHBOARDS_SETTINGS_FAILURE =
  'externalDashboardsSettings/FETCH_EXTERNAL_DASHBOARDS_SETTINGS_FAILURE'

export const UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_REQUEST =
  'externalDashboardsSettings/UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_REQUEST'
export const UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_SUCCESS =
  'externalDashboardsSettings/UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_SUCCESS'
export const UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_FAILURE =
  'externalDashboardsSettings/UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_FAILURE'

export const UPDATE_FIELD = 'externalDashboardsSettings/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'externalDashboardsSettings/SET_DEFAULT_DATA'
